import request from '@/utils/request'

export function editRole(data) {
  return request({
    url: `/role/update/${data.id}`,
    method: 'post',
    data: data,
  })
}

export function status(data) {
  return request({
    url: `/role/updateStatus/${data.id}`,
    method: 'post',
    params: {
      status: data.status
    },
  })
}

export function getRoleResource(id) {
  return request({
    url: `/role/listResource/${id}`,
    method: 'get',
  })
}

export function getRoleMenu(id) {
  return request({
    url: `/role/listMenu/${id}`,
    method: 'get',
  })
}

export function addRole(data) {
  return request({
    url: '/role/create',
    method: 'post',
    data: data,
  })
}

export function allowResource(data) {
  return request({
    url: '/role/allocResource',
    method: 'post',
    data: data,
  })
}

export function allowMenu(data) {
  return request({
    url: '/role/allocMenu',
    method: 'post',
    data: data,
  })
}

export function deleteRole(data) {
  return request({
    url: '/role/delete',
    method: 'post',
    params: {
      ids: data
    },
  })
}

export function getRoleList() {
  return request({
    url: '/role/listAll',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/role.js